const validateOnboardingStep = (step, previous, onBoarding) => {
  const currentStep = onBoarding.includes(step);
  if (currentStep) return false;

  const previousIndex = onBoarding.indexOf(previous);

  if (previousIndex >= 0) return true;

  return false;
};

export default validateOnboardingStep;
